import React from "react"

type ChevronProps = {
  dark?: boolean
}

export const Chevron: React.FC<ChevronProps> = ({ dark }) => (
  <div>
    <svg width="13" height="7" viewBox="0 0 13 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.25 1.5L6.5 5.5L1.75 1.5"
        stroke={dark ? `#BCBBB8` : `white`}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
)

Chevron.defaultProps = {
  dark: undefined,
}
